import { action } from 'app/actions';

export const RESET_ADD_PROFILE = 'addProfile/RESET_ADD_PROFILE';
export const resetProfile = () => action(RESET_ADD_PROFILE);

export const GET_SCHOOLS = 'addProfile/GET_SCHOOLS';
export const getSchools = payload => action(GET_SCHOOLS, { payload });

export const GET_PROFILE = 'addProfile/GET_PROFILE';
export const getProfile = payload => action(GET_PROFILE, { payload });

export const GET_PROFILES_TYPES = 'addProfile/GET_PROFILES_TYPES';
export const getProfilesTypes = payload => action(GET_PROFILES_TYPES, { payload });

export const GET_EVALUATIONS = 'addProfile/GET_EVALUATIONS';
export const getEvaluations = payload => action(GET_EVALUATIONS, { payload });

export const ADD_TEACHER = 'addProfile/ADD_TEACHER';
export const addTeacher = payload => action(ADD_TEACHER, { payload });

export const EDIT_TEACHER = 'addProfile/EDIT_TEACHER';
export const editTeacher = payload => action(EDIT_TEACHER, { payload });

export const GET_FILTERED_CATALOGINS = 'addProfile/GET_FILTERED_CATALOGINS';
export const getFilteredCatalogins = payload => action(GET_FILTERED_CATALOGINS, { payload });
